// extracted by mini-css-extract-plugin
export var copyableField = "_qj-4";
export var customerBadge = "_qj-0";
export var customerInfoTitle = "_qj-2";
export var details = "_qj-1";
export var dropdownContainer = "_qj-5";
export var dropdownImage = "_qj-6";
export var editAssigneeForm = "_qj-a";
export var editButton = "_qj-3";
export var email = "_qj-7";
export var hidden = "_qj-d";
export var input = "_qj-8";
export var saveButton = "_qj-b";
export var shopifyIcon = "_qj-c";
export var suggestionBadge = "_qj-e";
export var suggestionText = "_qj-f";
export var username = "_qj-9";